import { dispatch } from '../internal.js';
import { SET_LANG } from './actionTypes.js';
export const setLang = (lang) => {
    dispatch({
        type: SET_LANG,
        payload: { lang },
    });
};
//# sourceMappingURL=actions.js.map